module.exports = __webpack_public_path__ + "static/what-is-cryptocurrency-a73499052d6a83d1152332fac4453402.svg";